import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../../contexts/AuthContext";

const DeleteChallengeModal = ({ challenge, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { apiBaseUrl } = useAuth();

  const handleDelete = async () => {
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.delete(
        `${apiBaseUrl}/api/tournament/admin/${challenge.id}`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      setMessage("چلنج با موفقیت حذف شد");

      setTimeout(() => {
        onSuccess();
      }, 1000);
    } catch (error) {
      console.error("Error:", error);
      setMessage(error.response?.data?.message || "خطا در حذف چلنج");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-md w-full">
        <div className="flex justify-between items-center p-4 border-b border-gray-600">
          <h3 className="text-lg font-semibold text-white">تایید حذف چلنج</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-2xl w-8 h-8 flex items-center justify-center"
            disabled={loading}
          >
            ×
          </button>
        </div>

        <div className="p-6">
          {message && (
            <div
              className={`p-4 rounded-lg text-center mb-4 ${
                message.includes("موفقیت")
                  ? "bg-green-900 border border-green-600 text-green-400"
                  : "bg-red-900 border border-red-600 text-red-400"
              }`}
            >
              {message}
            </div>
          )}

          <div className="bg-yellow-900/30 border border-yellow-600 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <span className="text-yellow-400 text-2xl">⚠️</span>
              <div>
                <p className="text-yellow-300 font-medium mb-2">
                  آیا مطمئن هستید؟
                </p>
                <p className="text-yellow-200 text-sm">
                  این عملیات قابل بازگشت نیست و چلنج به طور کامل حذف خواهد شد.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-900 rounded-lg p-4 mb-6 space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-400">ID:</span>
              <span className="text-white font-medium">{challenge.id}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">نام:</span>
              <span className="text-white font-medium">{challenge.name}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">مدت:</span>
              <span className="text-white font-medium">
                {challenge.duration} روز
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">وضعیت:</span>
              <span className="text-white font-medium">
                {challenge.status === "in_progress"
                  ? "در حال انجام"
                  : "انجام شده"}
              </span>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex-1 py-3 px-6 bg-gray-600 hover:bg-gray-700 disabled:bg-gray-700 text-white font-medium rounded-lg transition duration-200"
            >
              انصراف
            </button>
            <button
              onClick={handleDelete}
              disabled={loading}
              className="flex-1 py-3 px-6 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition duration-200 flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                  در حال حذف...
                </>
              ) : (
                "حذف چلنج"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteChallengeModal;
